import React from 'react'
import Routes from '@brainstud/react-tbl/themes/pgw/v1/routes'
import { scrollTop } from '@brainstud/react-tbl/themes/pgw/v1/helpers'
import { withEndtest } from '@brainstud/react-tbl/themes/pgw/v1/containers'
import { Page, Animation } from '@brainstud/react-tbl/themes/pgw/v1/components/library'
import PageFooter from '@brainstud/react-tbl/themes/pgw/v1/components/views/page/PageFooter'
import { SummaryPassed, SummaryNotPassed } from 'content/endtest/Summary'
import { Quiz } from '@brainstud/react-widget-quiz'

class EndtestSummaryView extends React.Component {
  componentDidMount() {
    scrollTop()
    this.props.app.setLocation({ label: 'endtest' })
    this.props.app.triggerTheme(this.props.navigation.theme || 'default')
  }

  setProgress = (done) => {
    this.props.setNavigationProgress({
      id: this.props.navigation.id,
      data: {
        ...this.props.navigation.progress,
        progress: done ? 1 : 0,
        status: done ? 'done' : 'active',
      }
    })
    this.props.app.willProgress(this.props.navigation.prefix)
  }

  render() {
    return (
      <Page container>
        <Quiz.SummaryView
          match={this.props.match}
          location={this.props.location}
          passedComponent={SummaryPassed}
          setAppProgress={this.setProgress}
          notPassedComponent={SummaryNotPassed}
        />

        <Quiz.FooterView>
          {footer => (
            <Animation name="slideInDown" delay={300}>
              <PageFooter style={{ paddingTop: 0 }} {...footer} />
            </Animation>
          )}
        </Quiz.FooterView>
      </Page>
    )
  }
}

export default withEndtest(EndtestSummaryView)
